import { RefObject, useLayoutEffect } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { ResizeObserver } from 'resize-observer';

export const useResizeObserver = (ref: RefObject<HTMLDivElement>, scrollRef: RefObject<Scrollbars>): void => {
	useLayoutEffect(() => {
		const target = ref.current;
		if (target) {
			const observer = new ResizeObserver((entries) => {
				entries.forEach(() => {
					const scroll = scrollRef.current;
					if (!scroll) {
						return;
					}
					if (scroll.getScrollHeight() - scroll.getScrollTop() - scroll.getClientHeight() < 300) {
						scroll.scrollToBottom();
					}
				});
			});

			observer.observe(target);
			return (): void => observer.unobserve(target);
		}
	}, [ref, scrollRef]);
};
